import {DraftError} from './DraftError.js'

export class GetAdIdByCategoryAdPublisherError extends DraftError {
  #message

  static create({message}) {
    return new GetAdIdByCategoryAdPublisherError({message})
  }

  constructor({message}) {
    super(message)
    this.#message = message
  }

  toJSON() {
    return {message: this.#message}
  }
}
